import { render, staticRenderFns } from "./ExchangeStores.vue?vue&type=template&id=fb85e3a2"
import script from "./ExchangeStores.vue?vue&type=script&lang=js"
export * from "./ExchangeStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports